/**
 * Safely splits a full name string into first and last name components.
 * 
 * @param {string} fullName - The full name to split
 * @returns {object} { firstName: string, lastName: string }
 * 
 * Examples:
 *   splitFullName("Alex Potter") => { firstName: "Alex", lastName: "Potter" }
 *   splitFullName("Alex") => { firstName: "Alex", lastName: "" }
 *   splitFullName("John Q Public") => { firstName: "John", lastName: "Q Public" }
 */
export function splitFullName(fullName) {
  if (!fullName || typeof fullName !== "string") {
    return { firstName: "", lastName: "" };
  }

  const trimmed = fullName.trim();
  if (!trimmed) {
    return { firstName: "", lastName: "" };
  }

  // Split on first whitespace
  const parts = trimmed.split(/\s+/);
  
  if (parts.length === 1) {
    // Single name: use as first name, leave last name empty
    return { firstName: parts[0], lastName: "" };
  }

  // Multiple parts: first is firstName, rest is lastName
  const firstName = parts[0];
  const lastName = parts.slice(1).join(" ");

  return { firstName, lastName };
}
